(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('FavouriteFilter', FavouriteFilter);

    FavouriteFilter.$inject = ['$resource'];

    function FavouriteFilter ($resource) {
        var resourceUrl =  'api/favourite-filters/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
